export const tenantUserKeys = {
    all: ['tenant-users'] as const,
    lists: () => [...tenantUserKeys.all, 'list'] as const,
    list: () => [...tenantUserKeys.lists()] as const,
};
